import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';

const ItemCard = ({ dense, item, mediaSize, onClick }) => (
  <Card>
    <CardActionArea
      onClick={onClick}
      style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}
    >
      <CardMedia
        component="img"
        src={resizeImageUrl(item?.product?.image, mediaSize)}
        style={{ width: mediaSize }}
      />
      <Box p={dense ? 1 : 2}>
        <Typography
          component="div"
          variant={dense ? 'body2' : 'body1'}
          style={{ fontWeight: 500, lineHeight: 'inherit' }}
        >
          {item?.description}
        </Typography>
        <Box mt={dense ? 0 : 2}>
          <Typography component="div" variant="caption" color="textSecondary">
            SKU: {item?.sku}
          </Typography>
          <Typography component="div" variant="caption" color="textSecondary">
            EAN: {item?.ean ?? item?.product?.ean}
          </Typography>
        </Box>
      </Box>
    </CardActionArea>
  </Card>
);

ItemCard.propTypes = {
  dense: PropTypes.bool,
  item: PropTypes.object,
  mediaSize: PropTypes.number,
  onClick: PropTypes.func,
};

ItemCard.defaultProps = {
  dense: false,
  item: undefined,
  mediaSize: 150,
  onClick: undefined,
};

export default ItemCard;
